// TODO ideally this should be moved to platform
/**
 * Efficiently iterates through entity rows by given filter.
 * This function will execute `ReadonlyStorageBackendApi.list` requests in chunks.
 *
 * @param storage - storage to use for query
 * @param request - provide filtering
 * @param callback - callback to process each entity row, return `cancel: true` to cancel iteration. `deleted: true` if row was deleted from storage if you don't do this listing will fail
 * @param before - called before iteration starts
 */
export function forEachEntityRow(storage, request, callback, before) {
    const total = storage.count({ filter: request.filter });
    const settings = before(total);
    const limit = typeof settings === 'object' ? settings.buffer : 5000;
    let offset = 0;
    let idx = 0;
    while (true) {
        const response = storage.list({ filter: request.filter, orderBy: request.orderBy, limit: limit, offset: offset });
        if (response.rows.length > 0) {
            let deletedCount = 0;
            for (const row of response.rows) {
                const control = callback(row, idx++);
                if (typeof control === 'object') {
                    if (control.cancel) {
                        return;
                    }
                    if (control.deleted) {
                        deletedCount++;
                    }
                }
            }
            offset += limit;
            offset -= deletedCount;
        }
        else {
            return;
        }
    }
}
